import _ from 'lodash';
import React from 'react';
import postal from 'postal';
import Loading from '../../../shared/loading';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import ErrorBoundary from '../../../shared/error-boundary';
import {
  SortableFilterableTableHeader,
  SORT_DIRECTION,
  sortSimpleColumn,
  filterSimpleColumn,
} from '../../../shared/sortable-filterable-table-header';
import Category from './category';
import EditCategoryModal from './edit-category-modal';
import { getAll } from '../../../services/lwadmin/category/category-service';

function filterCategories(categories, state) {
  let filteredCategories = _(categories);

  filteredCategories = filterSimpleColumn(filteredCategories, 'name', state);

  return filteredCategories.value();
}

function sortCategories(categories, state) {
  let sortedCategories = _(categories);

  sortedCategories = sortSimpleColumn(sortedCategories, 'name', state);

  return sortedCategories.value();
}

function filterAndSortCategories(categories, state) {
  return sortCategories(filterCategories(categories, state), state);
}

export default class CategoriesTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      allCategories: [],
      categories: [],
      nameSortDirection: SORT_DIRECTION.unsorted,
      nameFilter: '',
    };
  }

  componentDidMount() {
    postal.subscribe({
      channel: 'lwadmin.categories.commands',
      topic: 'create-category',
      callback: () => this.createCategory(),
    });

    this.refresh();
  }

  createCategory() {
    this.editCategoryModal.present();
  }

  refresh() {
    this.loading.start();
    getAll()
      .then(result => {
        this.setState(state => {
          state.allCategories = _(result.data.categories)
            .map(p => new Category(p))
            .sortBy(x => x.name)
            .value();
          state.categories = filterAndSortCategories(state.allCategories, state);
          return state;
        });
      })
      .catch(err => defaultOnErrorHandler(err, 'Error loading categories'))
      .finally(() => this.loading.stop());
  }

  editCategory(e, category) {
    e && e.preventDefault && e.preventDefault();

    this.editCategoryModal.present(category.id);
  }

  sortName(direction) {
    this.setState(state => {
      state.nameSortDirection = direction;
      state.categories = filterAndSortCategories(state.allCategories, state);
      return state;
    });
  }

  filterName(filter) {
    this.setState(state => {
      state.nameFilter = filter;
      state.categories = filterAndSortCategories(state.allCategories, state);
      return state;
    });
  }

  render() {
    return (
      <ErrorBoundary>
        <div className="lwadmin-categories-table">
          <Loading ref={c => (this.loading = c)}>
            <table className="table table-hover">
              <thead>
                <tr>
                  <SortableFilterableTableHeader
                    onSort={direction => this.sortName(direction)}
                    onFilter={filter => this.filterName(filter)}
                  >
                    Name
                  </SortableFilterableTableHeader>
                  <th>Description</th>
                  <th>Assigned wires</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.state.categories.map(category => (
                  <tr key={category.id}>
                    <td>
                      {category.name}
                    </td>
                    <td>{category.description}</td>
                    <td>{category.stats.wires_count}</td>
                    <td className="table-tools">
                      <ul>
                        <li><a href={`/lwadmin/categories/${category.id}`}>View</a></li>
                        <li><a href="#" onClick={e => this.editCategory(e, category)}>Edit</a></li>
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Loading>
          <EditCategoryModal
            ref={c => (this.editCategoryModal = c)}
            categoryDidSave={() => this.refresh()}
          />
        </div>
      </ErrorBoundary>
    );
  }
}
